import React from 'react'
import { NavLink } from 'react-router-dom'

import './headerNav.css'

const HeaderNav = () => {
	return (
		<div className="nav-links d-flex align-items-center" style={{ gap: '3rem' }}>
			<NavLink to="/">Dashboard</NavLink>
			<NavLink to="/wip">WIP</NavLink>
			<NavLink to="/invoices">Invoices</NavLink>
			<NavLink to="/reports">Reports</NavLink>
			<NavLink to="/costs">Costs</NavLink>
		</div>
	)
}

export default HeaderNav
